import { createBrowserRouter, Navigate } from "react-router-dom";
import { LoginPage } from "./pages/LoginPage.tsx";
import { SignupPage } from "./pages/SignupPage.tsx";
import { ForgotPasswordPage } from "./pages/ForgotPasswordPage.tsx";
import { ResetPasswordPage } from "./pages/ResetPasswordPage.tsx";
import { DashboardRedirect } from "./pages/DashboardRedirect.tsx";
import { DashboardLayout } from "./pages/DashboardLayout.tsx";
import { UsagePage } from "./pages/UsagePage.tsx";
import { TeamPage } from "./pages/TeamPage.tsx";
import { DeveloperPage } from "./pages/DeveloperPage.tsx";
import { PlaygroundPage } from "./pages/PlaygroundPage.tsx";
import { BillingPage } from "./pages/BillingPage.tsx";
import { PlansPage } from "./pages/PlansPage.tsx";
import { OrganizationsPage } from "./pages/OrganizationsPage.tsx";
import { ProfilePage } from "./pages/ProfilePage.tsx";
import { ConnectMcpPage } from "./pages/ConnectMcpPage.tsx";
import { SsoSettingsPage } from "./pages/SsoSettingsPage.tsx";
import { AiProvidersPage } from "./pages/AiProvidersPage.tsx";
import { AuditLogsPage } from "./pages/AuditLogsPage.tsx";
import { AcceptInvitationPage } from "./pages/AcceptInvitationPage.tsx";
import { ProtectedRoute } from "./components/ProtectedRoute.tsx";
import { RouteErrorBoundary } from "./components/ErrorBoundary.tsx";

export const router = createBrowserRouter([
  {
    path: "/login",
    element: <LoginPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/signup",
    element: <SignupPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPasswordPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/reset-password",
    element: <ResetPasswordPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/connect/mcp",
    element: <ConnectMcpPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/accept-invitation/:invitationId",
    element: <AcceptInvitationPage />,
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/dashboard",
    element: (
      <ProtectedRoute>
        <DashboardRedirect />
      </ProtectedRoute>
    ),
    errorElement: <RouteErrorBoundary />,
  },
  {
    path: "/dashboard/:orgId",
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    errorElement: <RouteErrorBoundary />,
    children: [
      { index: true, element: <UsagePage /> },
      { path: "team", element: <TeamPage /> },
      { path: "developer", element: <DeveloperPage /> },
      { path: "playground", element: <PlaygroundPage /> },
      { path: "billing", element: <BillingPage /> },
      { path: "plans", element: <PlansPage /> },
      { path: "organizations", element: <OrganizationsPage /> },
      { path: "sso", element: <SsoSettingsPage /> },
      { path: "ai-providers", element: <AiProvidersPage /> },
      { path: "audit", element: <AuditLogsPage /> },
      { path: "profile", element: <ProfilePage /> },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/dashboard" replace />,
  },
]);
